<template>
  <div style="display: contents;">
    <svg v-if="isNotSpecial" :class="svgClass" aria-hidden="true">
      <use :xlink:href="iconName"></use>
    </svg>
    <!-- <img v-if="!isNotSpecial" :class="svgClass" :src="iconName2" class="svg-icon"/> -->
    <settings-icon v-if="!isNotSpecial && isSettings " class="svg-icon2"></settings-icon>
    <user-icon v-if="!isNotSpecial && isUser " class="svg-icon2"></user-icon>
    <file-text-icon v-if="!isNotSpecial && isFileText " class="svg-icon2"></file-text-icon>
    <list-icon v-if="!isNotSpecial && isListIcon " class="svg-icon2"></list-icon>
    <calendar-icon v-if="!isNotSpecial && isCalendarIcon " class="svg-icon2"></calendar-icon>
    <copy-icon v-if="!isNotSpecial && isCopyIcon " class="svg-icon2"></copy-icon>
    <grid-icon v-if="!isNotSpecial && isGridIcon " class="svg-icon2"></grid-icon>
    <map-pin-icon v-if="!isNotSpecial && isMapPinIcon " class="svg-icon2"></map-pin-icon>
    <award-icon v-if="!isNotSpecial && isAwardIcon " class="svg-icon2"></award-icon>
  </div>
</template>

<script>
// import gears from '@/assets/options-gear.svg'
import { SettingsIcon, UserIcon, FileTextIcon, ListIcon, CalendarIcon, CopyIcon, GridIcon, MapPinIcon, AwardIcon } from 'vue-feather-icons'

export default {
  name: 'svg-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String
    },
    specialBoi: {
      type: Boolean
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    iconName2() {
      var dingus = this.iconClass
      if (dingus === 'settings') {
        return gears
      }
      return ''
    },
    isNotSpecial() {
      if (!this.specialBoi) {
        return true
      } else {
        return false
      }
    },
    isSettings() {
      if (this.iconClass === 'settings') {
        return true
      }
    },
    isUser() {
      if (this.iconClass === 'user') {
        return true
      }
    },
    isFileText() {
      if (this.iconClass === 'fileText') {
        return true
      }
    },
    isListIcon() {
      if (this.iconClass === 'list') {
        return true
      }
    },
    isCalendarIcon() {
      if (this.iconClass === 'calendar') {
        return true
      }
    },
    isCopyIcon() {
      if (this.iconClass === 'copy') {
        return true
      }
    },
    isGridIcon() {
      if (this.iconClass === 'grid') {
        return true
      }
    },
    isMapPinIcon() {
      if (this.iconClass === 'map-pin') {
        return true
      }
    },
    isAwardIcon() {
      if (this.iconClass === 'award') {
        return true
      }
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    }
  },
  components: {
    SettingsIcon,
    UserIcon,
    FileTextIcon,
    ListIcon,
    CalendarIcon,
    CopyIcon,
    GridIcon,
    MapPinIcon,
    AwardIcon
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.svg-icon2 {
  width: 1.2em;
  height: 1.2em;
  margin-right: 16px;
  vertical-align: -0.25em;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue